import styles from '../PropertyPanel.module.css';

function NumberField({ label, value, onChange, unit = 'px', min, max }) {
  const numValue = parseInt(value) || 0;

  const handleChange = (e) => {
    const num = e.target.value;
    onChange(num ? `${num}${unit}` : '');
  };

  return (
    <label className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <div className={styles.numberRow}>
        <input
          type="number"
          className={styles.numberInput}
          value={numValue}
          onChange={handleChange}
          min={min}
          max={max}
        />
        <span className={styles.numberUnit}>{unit}</span>
      </div>
    </label>
  );
}

export default NumberField;
